import React, { useState, lazy, Suspense, FormEvent } from 'react';
import { ArrowRight } from 'lucide-react';

const OfferRequestForm = lazy(() => import('@/components/OfferRequestForm'));

const content = {
  heading: 'Vezi dacă panourile fotovoltaice merită pentru casa ta.',
  cta: 'Verifică gratuit în 2 minute',
  trust: 'Analiză gratuită · Fără obligații · Răspuns în 48h',
};

const FinalCTA: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [address, setAddress] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (address.trim()) {
      setIsFormOpen(true);
    }
  };

  return (
    <section className="py-20 md:py-28 bg-foreground">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold text-background leading-tight mb-4">
            {content.heading}
          </h2>

          <form onSubmit={handleSubmit} className="max-w-md mx-auto mb-4">
            <div className="relative flex items-center bg-background rounded-full overflow-hidden shadow-lg">
              <label htmlFor="cta-address" className="sr-only">Adresă</label>
              <input
                id="cta-address"
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Introdu adresa ta"
                className="flex-1 px-6 py-4 text-base text-foreground placeholder:text-muted-foreground focus:outline-none bg-transparent"
                required
              />
              <button
                type="submit"
                className="flex-shrink-0 m-1.5 px-5 h-11 rounded-full bg-accent hover:bg-accent/90 transition-colors flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-accent text-accent-foreground text-sm font-semibold whitespace-nowrap"
              >
                <span className="hidden sm:inline">{content.cta}</span>
                <ArrowRight size={18} className="sm:hidden" />
              </button>
            </div>
          </form>

          <p className="text-background/50 text-sm">{content.trust}</p>
        </div>
      </div>

      {isFormOpen && (
        <Suspense fallback={null}>
          <OfferRequestForm open={isFormOpen} onOpenChange={setIsFormOpen} defaultLocality={address} />
        </Suspense>
      )}
    </section>
  );
};

export default FinalCTA;
